import { useState } from 'react';

export type MixedUseAttestation = { businessPercent: string; businessAmount: string; statementText: string };

function allocationAmount(amount: string, percent: number): string {
  const value = Number(amount);
  if (!Number.isFinite(value)) return 'unavailable';
  return (value * percent / 100).toFixed(4);
}

export function MixedUseAttestationDialog({ amount, onSubmit }: { amount: string; onSubmit: (attestation: MixedUseAttestation) => void }) {
  const [percent, setPercent] = useState(100);
  const [statement, setStatement] = useState('');
  const computedAmount = allocationAmount(amount, percent);
  return (
    <form className="rounded-[10px] border border-border bg-card p-4" onSubmit={(event) => { event.preventDefault(); if (statement.length === 0 || computedAmount === 'unavailable') return; onSubmit({ businessPercent: percent.toFixed(2), businessAmount: computedAmount, statementText: statement }); }}>
      <h2 className="font-semibold">Move to Business</h2>
      <label className="mt-3 flex flex-col gap-2 text-sm" htmlFor="promotion-business-percent">
        <span className="font-semibold">Business use percentage · {percent}%</span>
        <input id="promotion-business-percent" type="range" min={1} max={100} value={percent} onChange={(event) => setPercent(Number(event.target.value))} aria-label="Business use percentage" />
      </label>
      <p className="mt-2 text-sm" aria-live="polite">Business amount · {computedAmount}</p>
      <label className="mt-3 flex flex-col gap-1 text-sm" htmlFor="promotion-statement">
        <span className="font-semibold">Statement</span>
        <textarea id="promotion-statement" value={statement} onChange={(event) => setStatement(event.target.value)} rows={3} className="rounded-md border border-input px-3 py-2" />
      </label>
      <button type="submit" disabled={statement.length === 0 || computedAmount === 'unavailable'} className="mt-3 min-h-11 rounded-md bg-foreground px-4 text-sm font-semibold text-background">Move to Business</button>
    </form>
  );
}

export default MixedUseAttestationDialog;

